import api from '.';

export const enums = async (table, field, filter = null) => {
    try {
        const { data } = await api.get('/serviceEnums', {
            params: { table, field, filter },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const menu = async (menu) => {
    try {
        const { data } = await api.get('/serviceMenu', { params: { menu } });
        return data;
    } catch (error) {
        return error;
    }
};

export const menuSub = async (menuId, descricao) => {
    try {
        const { data } = await api.get('/serviceMenuSub', {
            params: { menuId, descricao },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const tabelaById = async (empresaId, tabela, id) => {
    if (!id) {
        return null;
    }
    try {
        const { data } = await api.get('/serviceTabelaById', {
            params: { empresaId, tabela, id },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const tabela = async (empresaId, tabela, order) => {
    try {
        const { data } = await api.get('/serviceTabela', {
            params: { empresaId, tabela, order },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const retornaPais = async (id, descricao) => {
    try {
        const { data } = await api.get('/retornaPais', {
            params: { id, descricao },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
export const embalagemByProdutoId = async (empresaId, produtoId) => {
    if (!empresaId || !produtoId) {
        return null;
    }
    try {
        const { data } = await api.get('/serviceEmbalagemByProdutoId', {
            params: { empresaId, produtoId },
        });

        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const fatorByEmbalagemId = async (empresaId, embalagemId) => {
    if (!empresaId || !embalagemId) {
        return;
    }
    try {
        const { data } = await api.get('/serviceFatorByEmbalagemId', {
            params: { empresaId, embalagemId },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
/**
 *
 * @param {*} empresaId
 * @param {*} pessoaId
 * @param {*} operacaoId
 * @param {*} entrada
 * @param {*} liberada
 * @param {*} locacao
 * @param {*} saida
 * @param {*} servico
 * @returns
 */
export const precoByPessoaId = async ({ empresaId, pessoaId, operacaoId, entrada, liberada, locacao, saida, servico }) => {
    if (!pessoaId) {
        return null;
    }
    try {
        const { data } = await api.get('/serviceTabelaPrecoByPessoaId', {
            params: { empresaId, pessoaId, operacaoId, entrada, liberada, locacao, saida, servico },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const pessoaTabelaPrecos = async (novaTabelaPreco) => {
    try {
        const { data } = await api.post('/pessoa/tabelaPreco', novaTabelaPreco);
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const campoTabelaById = async (empresaId, campo, tabela, id) => {
    try {
        const { data } = await api.get('/serviceCampoTabelaById', {
            params: { empresaId, campo, tabela, id },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
/**
 * Muito utilizado para retornar situacao
 * @param {*} empresaId
 * @param {*} tabela
 * @param {*} descricao
 * @returns
 */
export const TabelaByDescricao = async (empresaId, tabela, descricao) => {
    try {
        const { data } = await api.get('/serviceTabelaByDescricao', {
            params: { empresaId, tabela, descricao },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
//duplicidades
export const duplicidadeDescricao = async (empresaId, tabela, descricao) => {
    if (!empresaId || !tabela || !descricao) return;
    try {
        const data = await api.get('/serviceDuplicidadeDescricao', {
            params: { empresaId, tabela, descricao },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const duplicidadeCentroCustoLimite = async (empresaId, centroCustoId, mes) => {
    try {
        const { data } = await api.get('/centroCustoLimite/duplicidade/', {
            params: { empresaId, centroCustoId, mes },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const duplicidadeProdutoModelo = async (empresaId, fabricanteId, descricao) => {
    try {
        const { data } = await api.get('/produtoModelo/duplicidade/', {
            params: { empresaId, fabricanteId, descricao },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

/**
 * funciona quando varios itens selecionados na grid retorna os dados
 * @param {*} selectedUUIDs
 * @param {*} tabela
 * @returns
 */
export const retornaDataByRowSelecteds = (selectedUUIDs, tabela) => api.post('/retornaDataByRowSelecteds', selectedUUIDs, tabela);
